import { motion } from "framer-motion";
import { ServicesSection } from "../components/sections/ServicesSection";
import { ClientFlow } from "../components/sections/ClientFlow";
import { ProcessSection } from "../components/sections/ProcessSection";
import { ContactSection } from "../components/sections/ContactSection";

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="bg-[#050505] text-white pt-40 pb-20 md:pt-48 md:pb-28 px-6" data-testid="services-hero">
        <div className="max-w-7xl mx-auto">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-white/30" />
            <span className="text-xs uppercase tracking-[0.24em]" style={{ color: "var(--gold)" }}>Co robimy</span>
          </motion.div>
          <div className="overflow-hidden">
            <motion.h1 initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="text-5xl sm:text-6xl md:text-7xl tracking-tightest leading-[0.98] font-semibold max-w-4xl">
              Usługi, które porządkują pracę i <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>wspierają rozwój</span> firmy.
            </motion.h1>
          </div>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.8 }}
            className="mt-8 text-lg md:text-xl text-white/55 max-w-2xl leading-relaxed">
            Tworzymy praktyczne rozwiązania cyfrowe, które pomagają lepiej prezentować ofertę, usprawniać komunikację i oszczędzać czas.
          </motion.p>
        </div>
      </section>
      <ServicesSection showHeader={false} />
      <ClientFlow />
      <ProcessSection />
      <ContactSection />
    </div>
  );
}
